import proportional from '../../../../node_modules/shido.proportional.js/src/proportional.js'

const Fancybox = () => {
  $("[data-fancybox]").fancybox({
    afterShow : () => {
      new proportional().init()
    }
  })
}

export default Fancybox
